import { getI18nJsonProp } from "@/shared/i18n/locales/getI18nJsonProp";
import productDetails from "./product-details.json";

export default {
  ...getI18nJsonProp(productDetails, "wcLib"),
};
